module.exports = __webpack_public_path__ + "img/03-JS-map-out-your-job-search.3954f344.svg";